module.exports = __webpack_public_path__ + "static/img/5.72d7664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/5.jpg
// module id = DNpt
// module chunks = 1